import styled from "styled-components";

export default styled.div`
  overflow: hidden;
  position: relative;
  width: 100%;
  margin: 0 10px;
`;
